import Patients from './components/pages/Patients'
import CreatePatients from './components/pages/CreatePatients'
import EditPatients from './components/pages/EditPatients'
import Login from './components/pages/Login'
import Register from './components/pages/Register'
import ConfirmEmail from './components/pages/ConfirmEmail'
import EmailConfirmed from './components/pages/EmailConfirmed'
import ProfileSettings from './components/pages/ProfileSettings'
import ProfileInfo from './components/pages/ProfileInfo'

import CgaWelcome from './components/pages/CgaWelcome'
import Category from './components/pages/Category'
import CategoryStep from './components/pages/CategoryStep'
import CommonSense from './components/pages/CommonSense'
import Summary from './components/pages/Summary'
import Sheets from './components/pages/Sheets'
import CreateSheet from './components/pages/CreateSheet'

import PageNotFound from './components/pages/PageNotFound'
import Languages from './components/pages/admin/Languages.vue'
import ModifyTranslations from './components/pages/admin/ModifyTranslations.vue'
import ModifyKeys from './components/pages/admin/ModifyKeys.vue'

import AdminDashboard from './components/pages/admin/Dashboard'

import AdminLogin from './components/pages/admin/Login'
import AdminProfileInfo from './components/pages/admin/ProfileInfo'

import AdminCategories from './components/pages/admin/Categories'
import AdminCreateCategory from './components/pages/admin/CreateCategory'
import AdminEditCategory from './components/pages/admin/CategoryEdit'
import AdminReorderCategory from './components/pages/admin/CategoriesReorder'

import AdminTestTypes from './components/pages/admin/TestTypes'
import AdminCreateTestType from './components/pages/admin/CreateTestType'
import AdminEditTestType from './components/pages/admin/TestTypeEdit.vue'
import AdminReorderTestTypes from './components/pages/admin/TestTypesReorder.vue'

import AdminCreateCategoryStep from './components/pages/admin/CreateCategoryStep'
import AdminCategoryStepSequences from './components/pages/admin/CategoryStepSequences'
import AdminCategorySteps from './components/pages/admin/CategorySteps'
import AdminEditCategoryStep from './components/pages/admin/CategoryStepEdit'
import AdminReorderCategorySteps from './components/pages/admin/CategoryStepsReorder'

import AdminCreateQuestionnaire from './components/pages/admin/CreateQuestionnaire'
import AdminQuestionnaires from './components/pages/admin/Questionnaire'
import AdminEditQuestionnaire from './components/pages/admin/QuestionnaireEdit'

import AdminDoctors from './components/pages/admin/Doctors'
import AdminDoctorInfo from './components/pages/admin/DoctorInfo'
import AdminEditDoctor from './components/pages/admin/EditDoctor'
import AdminRegisterDoctor from './components/pages/admin/RegisterDoctor'
import AdminLanguages from './components/pages/admin/Languages'
import AdminAddLanguage from './components/pages/admin/AddLanguage'
import AdminTranslationKeys from './components/pages/admin/TranslationKeys'
import AdminAddTranslationKey from './components/pages/admin/AddTranslationKey'
import AdminModifyTranslations from './components/pages/admin/ModifyTranslations.vue'
import AdminModifyLanguages from './components/pages/admin/ModifyLanguages.vue'

import AdminMembershipOrders from './components/pages/admin/MembershipOrders.vue'

import ResetPassword from './components/pages/ResetPassword.vue'
import ForgottenPassword from './components/pages/ForgottenPassword.vue'

import Membership from './components/pages/Membership.vue'
import OrderMembership from './components/pages/OrderMembership.vue'
import OrderSuccess from './components/pages/OrderSuccess.vue'
import SetupMfa from './components/pages/admin/SetupMfa.vue'

import store from './store'

const guestGuard = async(to, from, next) => {
    await store.dispatch("validateAccessToken")
        .then(response => {
            mfaGuard(to, from, next);
        })
        .catch(error => {
            next('/login');
        });
};

const membershipGuard = async (to, from, next) => {
    await store.dispatch("validateDoctorsMembership")
        .then(response => {
            guestGuard(to, from, next);
        })
        .catch(error => {
            next('/membership/order');
        });
};

const mfaGuard = async (to, from, next) => {
    await store.dispatch("validateUserMfa")
        .then(response => {
            roleGuard(to, from, next);
        })
        .catch(error => {
            let userRoles = from.meta.roles;
            if (userRoles !== undefined && userRoles.includes("Admin")) {
                next('/admin/mfa');
            } else {
                next('/profile/settings#two-factor');
            }
        });
};

const authrozedGuard = async(to, from, next) => {
    await store.dispatch("validateAccessToken")
        .then(response => {
            next('/patients');
        })
        .catch(error => {
            roleGuard(to, from, next);
        });
};

const roleGuard = async(to, from, next) => {
    if (typeof(to.meta.authorization) != 'undefined') {
        let userRole = to.meta.authorization.roles;
        if (userRole == store.getters.userRole) {
            next();
        } else {
            next({ name: to.meta.authorization.redirect });
        }
    } else {
        next();
    }
};

const cgaGuard = async(to, from, next) => {
    if (!store.getters.cgaStatus) {
        next('/patients');
    } else {
        await guestGuard(to, from, next);
    }
};

const doctorRouteMeta = {
    layout: 'layout',
    authorization: {
        roles: ['Doctor'],
        redirect: 'admin'
    }
};

const adminRouteMeta = {
    layout: 'admin-layout',
    authorization: {
        roles: ['Admin'],
        redirect: 'page-not-found'
    }
};

export const routes = [
    {
        name: 'patients',
        path: '/patients',
        component: Patients,
        props: (route) => ({ page: route.query.p }),
        beforeEnter: async(to, from, next) => {
            if (store.getters.cgaStatus) {
                next('/cga');
            } else {
                await membershipGuard(to, from, next);
            }
        },
        meta: doctorRouteMeta
    },
    {
        name: 'patients-add',
        path: '/patients/add',
        component: CreatePatients,
        beforeEnter: async(to, from, next) => {
            if (store.getters.cgaStatus) {
                next('/cga');
            } else {
                await membershipGuard(to, from, next);
            }
        },
        meta: doctorRouteMeta
    },
    {
        name: 'patients-edit',
        path: '/patients/:id/edit',
        component: EditPatients,
        beforeEnter: async(to, from, next) => {
            if (store.getters.cgaStatus) {
                next('/cga');
            } else {
                await membershipGuard(to, from, next);
            }
        },
        meta: doctorRouteMeta
    },
    {
        name: 'login',
        path: '/login',
        component: Login,
        meta: {
            layout: 'auth-layout'
        },
        beforeEnter: authrozedGuard
    },
    {
        name: 'register',
        path: '/register',
        component: Register,
        meta: {
            layout: 'auth-layout'
        },
        beforeEnter: authrozedGuard
    },
    {
        name: 'confirm-email',
        path: '/confirm-email',
        component: ConfirmEmail,
        meta: {
            layout: 'auth-layout'
        },
        beforeEnter: authrozedGuard
    },
    {
        name: 'email-confirmed',
        path: '/email-confirmed',
        component: EmailConfirmed,
        meta: {
            layout: 'auth-layout'
        },
        beforeEnter: authrozedGuard
    },
    {
        name: 'forgotten-password',
        path: '/forgotten-password',
        component: ForgottenPassword,
        meta: {
            layout: 'auth-layout'
        },
        beforeEnter: authrozedGuard
    },
    {
        name: 'reset-password',
        path: '/reset-password',
        component: ResetPassword,
        meta: {
            layout: 'auth-layout'
        },
        props: (route) => ({ 
            id: route.query.id ,
            token: route.query.t ,
        }),
        beforeEnter: authrozedGuard
    },
    {
        name: 'languages',
        path: '/admin/languages',
        component: Languages,
        props: (route) => ({ page: route.query.p }),
        meta: adminRouteMeta
    },
    {
        name: 'modify-translations',
        path: '/admin/languages',
        component: ModifyTranslations,
        meta: adminRouteMeta
    },
    {
        name: 'modify-keys',
        path: '/admin/languages/:key/modify-key',
        component: ModifyKeys,
        meta: adminRouteMeta
    },
    {
        name: 'profile-settings',
        path: '/profile/settings',
        component: ProfileSettings,
        beforeEnter: roleGuard,
        meta: doctorRouteMeta
    },
    {
        name: 'profile-info',
        path: '/profile/info',
        component: ProfileInfo,
        beforeEnter: guestGuard,
        meta: doctorRouteMeta
    },
    {
        name: 'category-main',
        path: '/categories/:id',
        component: Category,
        beforeEnter: membershipGuard,
        meta: doctorRouteMeta
    },
    {
        name: 'category-step',
        path: '/categories/:categoryId/steps/:stepId',
        component: CategoryStep,
        beforeEnter: membershipGuard,
        meta: doctorRouteMeta
    },
    {
        name: 'common-sense',
        path: '/common-sense',
        component: CommonSense,
        beforeEnter: cgaGuard,
        meta: doctorRouteMeta
    },
    {
        name: 'cga',
        path: '/cga',
        component: CgaWelcome,
        beforeEnter: cgaGuard,
        meta: doctorRouteMeta
    },
    {
        name: 'summary',
        path: '/summary',
        component: Summary,
        beforeEnter: cgaGuard,
        meta: doctorRouteMeta
    },
    {
        name: 'sheets',
        path: '/sheets',
        component: Sheets,
        props: (route) => ({ page: route.query.p }),
        beforeEnter: cgaGuard,
        meta: doctorRouteMeta
    },
    {
        name: 'create-sheet',
        path: '/sheets/create',
        component: CreateSheet,
        beforeEnter: cgaGuard,
        meta: doctorRouteMeta
    },
    {
        name: 'membership',
        path: '/membership',
        component: Membership,
        beforeEnter: guestGuard,
        meta: doctorRouteMeta
    },
    {
        name: 'order-membership',
        path: '/membership/order',
        component: OrderMembership,
        beforeEnter: guestGuard,
        meta: doctorRouteMeta
    },
    {
        name: 'order-success',
        path: '/membership/order/success',
        component: OrderSuccess,
        beforeEnter: guestGuard,
        meta: doctorRouteMeta
    },
    // admin routes

    {
        name: 'admin',
        path: '/admin',
        component: AdminDashboard,
        beforeEnter: async(to, from, next) => {
            await store.dispatch("validateAccessToken")
                .then(response => {
                    roleGuard(to, from, next);
                })
                .catch(error => {
                    next('/admin/login');
                });
        },
        meta: adminRouteMeta
    },
    {
        name: 'admin-login',
        path: '/admin/login',
        component: AdminLogin,
        meta: {
            layout: 'admin-auth-layout',
            roles: ['Admin']
        },
        beforeEnter: authrozedGuard
    },
    {
        name: 'admin-profile-settings',
        path: '/admin/profile/settings',
        component: ProfileSettings,
        beforeEnter: guestGuard,
        meta: adminRouteMeta
    },
    {
        name: 'admin-profile-info',
        path: '/admin/profile/info',
        component: AdminProfileInfo,
        beforeEnter: guestGuard,
        meta: adminRouteMeta
    },

    // Category
    {
        name: 'admin-categories',
        path: '/admin/categories',
        component: AdminCategories,
        beforeEnter: guestGuard,
        meta: adminRouteMeta
    },
    {
        name: 'admin-create-category',
        path: '/admin/categories/add',
        component: AdminCreateCategory,
        beforeEnter: guestGuard,
        meta: adminRouteMeta
    },
    {
        name: 'admin-edit-category',
        path: '/admin/categories/:categoryId/edit/',
        component: AdminEditCategory,
        beforeEnter: guestGuard,
        meta: adminRouteMeta
    },
    {
        name: 'admin-reorder-category',
        path: '/admin/categories/reorder',
        component: AdminReorderCategory,
        beforeEnter: guestGuard,
        meta: adminRouteMeta
    },
    // Test Types
    {
        name: 'admin-test-types',
        path: '/admin/test-types/',
        component: AdminTestTypes,
        beforeEnter: guestGuard,
        meta: adminRouteMeta
    },
    {
        name: 'admin-create-test-types',
        path: '/admin/test-types/add',
        component: AdminCreateTestType,
        beforeEnter: guestGuard,
        meta: adminRouteMeta
    },
    {
        name: 'admin-edit-test-types',
        path: '/admin/test-types/edit/:id',
        component: AdminEditTestType,
        beforeEnter: guestGuard,
        meta: adminRouteMeta
    },
    {
        name: 'admin-reorder-test-types',
        path: '/admin/test-types/reorder',
        component: AdminReorderTestTypes,
        beforeEnter: guestGuard,
        meta: adminRouteMeta
    },
    // Category Steps
    {
        name: 'admin-category-steps',
        path: '/admin/categories/:categoryId/steps',
        component: AdminCategorySteps,
        beforeEnter: guestGuard,
        meta: adminRouteMeta
    },
    {
        name: 'admin-category-step-sequences',
        path: '/admin/categories/:categoryId/step-sequences',
        component: AdminCategoryStepSequences,
        beforeEnter: guestGuard,
        meta: adminRouteMeta
    },
    {
        name: 'admin-create-category-step',
        path: '/admin/categories/:categoryId/steps/add',
        component: AdminCreateCategoryStep,
        beforeEnter: guestGuard,
        meta: adminRouteMeta
    },
    {
        name: 'admin-edit-category-step',
        path: '/admin/categories/:categoryId/steps/:stepId/edit/',
        component: AdminEditCategoryStep,
        beforeEnter: guestGuard,
        meta: adminRouteMeta
    },
    {
        name: 'admin-reorder-category-steps',
        path: '/admin/categories/:categoryId/steps/reorder/',
        component: AdminReorderCategorySteps,
        beforeEnter: guestGuard,
        meta: adminRouteMeta
    },
    // Questionnaires
    {
        name: 'admin-create-questionnaire',
        path: '/admin/questionnaires/add',
        component: AdminCreateQuestionnaire,
        beforeEnter: guestGuard,
        meta: adminRouteMeta
    },
    {
        name: 'admin-edit-questionnaire',
        path: '/admin/questionnaires/:questionnaireId/edit/',
        component: AdminEditQuestionnaire,
        beforeEnter: guestGuard,
        meta: adminRouteMeta
    },
    {
        name: 'admin-questionnaire',
        path: '/admin/questionnaires/:questionnaireId',
        component: AdminQuestionnaires,
        beforeEnter: guestGuard,
        meta: adminRouteMeta
    },

    {
        name: 'admin-doctors',
        path: '/admin/doctors',
        component: AdminDoctors,
        beforeEnter: guestGuard,
        meta: adminRouteMeta
    },
    {
        name: 'admin-register-doctor',
        path: '/admin/doctors/register',
        component: AdminRegisterDoctor,
        beforeEnter: guestGuard,
        meta: adminRouteMeta
    },
    {
        name: 'admin-info-doctor',
        path: '/admin/doctors/info/:id',
        component: AdminDoctorInfo,
        beforeEnter: guestGuard,
        meta: adminRouteMeta
    },
    {
        name: 'admin-edit-doctor',
        path: '/admin/doctors/edit/:id',
        component: AdminEditDoctor,
        beforeEnter: guestGuard,
        meta: adminRouteMeta
    },
    {
        name: 'admin-languages',
        path: '/admin/languages',
        component: AdminLanguages,
        beforeEnter: guestGuard,
        meta: adminRouteMeta
    },
    {
        name: 'admin-edit-language',
        path: '/admin/languages/:langCode/edit',
        component: AdminModifyLanguages,
        beforeEnter: guestGuard,
        meta: adminRouteMeta
    },
    {
        name: 'admin-add-language',
        path: '/admin/languages/add',
        component: AdminAddLanguage,
        beforeEnter: guestGuard,
        meta: adminRouteMeta
    },
    {
        name: 'admin-translation-keys',
        path: '/admin/translation-keys',
        component: AdminTranslationKeys,
        props: (route) => ({ page: route.query.p }),
        beforeEnter: guestGuard,
        meta: adminRouteMeta
    },
    {
        name: 'admin-add-translation-keys',
        path: '/admin/translation-keys/add',
        component: AdminAddTranslationKey,
        beforeEnter: guestGuard,
        meta: adminRouteMeta
    },
    {
        name: 'modify-translations',
        path: '/admin/languages/:langCode/translations',
        component: AdminModifyTranslations,
        beforeEnter: guestGuard,
        meta: adminRouteMeta
    },

    {
        name: 'admin-membership-orders',
        path: '/admin/membership-orders',
        component: AdminMembershipOrders,
        beforeEnter: guestGuard,
        meta: adminRouteMeta
    },

    {
        name: 'admin-setup-mfa',
        path: '/admin/mfa',
        component: SetupMfa,
        beforeEnter: roleGuard,
        meta: adminRouteMeta
    },

    // error routes
    {
        name: 'page-not-found',
        path: '/404',
        component: PageNotFound,
        meta: {
            layout: 'auth-layout'
        },
    },
    {
        name: 'redirect',
        path: '*',
        redirect: '/404'
    },
    {
        name: 'redirect-to-patients',
        path: '/',
        redirect: '/patients'
    },
]